export default __webpack_public_path__ + "static/media/B28.7a7a6408.png";